import { createSlice } from "@reduxjs/toolkit";
import { getMe, getTenants, loginThunk, magicSigninThunk } from "./thunks";
import httpClient from "../../api/httpClient";
import {
  getLocalStorageItem,
  SELECTED_TENANT_ID,
  setLocalStorageItem,
} from "../../constant/localStorage";

const initialState = {
  tenants: {},
  user: null,
  selectedTenantId: null,
  loading: true,
  tenantsLoading: true,
  isLoggedIn: Boolean(httpClient.getAccessToken()),
};

const handleLoginFulfilled = (state, action) => {
  state.isLoggedIn = true;
  state.user = {
    ...action.payload,
    user_id: action?.payload?.id || action?.payload?.user_id,
  };
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;

      if (key === "selectedTenantId" && value) {
        setLocalStorageItem(SELECTED_TENANT_ID, value);
      }

      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMe.fulfilled, (state, action) => {
        const user = action.payload;
        state.user = user;
        state.loading = false;
      })
      .addCase(getTenants.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.tenants = data.reduce((acc, tenant) => {
          acc[tenant?.id] = tenant;
          return acc;
        }, {});

        const prevTenantId = getLocalStorageItem(SELECTED_TENANT_ID);

        const selectedTenant = data?.find(
          (tenant) => tenant?.id === prevTenantId,
        );

        if (selectedTenant?.id) {
          state.selectedTenantId = selectedTenant.id;
        } else {
          const firstTenant = data?.[0];

          if (firstTenant?.id) {
            state.selectedTenantId = firstTenant.id;
            setLocalStorageItem(SELECTED_TENANT_ID, firstTenant.id);
          }
        }
        state.tenantsLoading = false;
      })
      .addCase(loginThunk.fulfilled, handleLoginFulfilled)
      .addCase(magicSigninThunk.fulfilled, handleLoginFulfilled);
  },
});

export const { setKeyValue } = userSlice.actions;

export default userSlice.reducer;
